/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_Source_PxkInputs */

const vi_sl_detail_label_source_pxk = /** @type {(inputs: Sl_Detail_Label_Source_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất lô chè mua (nguồn)`)
};

/**

* @param {Sl_Detail_Label_Source_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_source_pxk = /** @type {((inputs?: Sl_Detail_Label_Source_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_Source_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_source_pxk(inputs)
});